import React from 'react';
import RangeField from 'components/pure/utils/form/RangeField';
import ConfigurationOption from 'components/triggers/ConfigurationOption';
import BothIcon from '@material-ui/icons/Group';
import InternalIcon from '@material-ui/icons/GroupAdd';
import CallerIcon from '@material-ui/icons/RecordVoiceOver';
import {SpeakerCondition} from 'records/CallTrigger';
import PersonIcon from 'components/pure/utils/icon/PersonIcon';
import SelectField from 'components/pure/utils/form/SelectField';
import './TopicCoverageSelection.styl';

export default class TopicCoverageSelection extends React.Component {
  render() {
    const {condition, filterWords} = this.props;

    const selectedValue = condition.keywordTopicPhrase && condition.keywordTopicPhrase.filterWordId;

    const topics = filterWords // all topics.
      .map(w => ({label: w.word, value: w.id}))
      .toArray();

    const range = condition.range;
    return (
      <div className="topic-coverage-selection">
        <span>What percentage of the call has this topic?</span>
        <RangeField
          start={range.start}
          end={range.end}
          onValueChange={range => this.props.conditionChange(condition.set('range', range))}
          formatLabel={_ => ''}
          showInputRange={true}
          suffix="%"
        />
        <div className="user-type-selection">
          of
          <div className="configuration-group user-type">
            <ConfigurationOption
              label="Caller"
              icon={<CallerIcon />}
              active={condition.speakerType === SpeakerCondition.CALLER}
              onClick={() =>
                this.props.conditionChange(condition.set('speakerType', SpeakerCondition.CALLER))
              }
            />
            <ConfigurationOption
              label="Internal"
              icon={<InternalIcon />}
              active={condition.speakerType === SpeakerCondition.INTERNAL}
              onClick={() =>
                this.props.conditionChange(condition.set('speakerType', SpeakerCondition.INTERNAL))
              }
            />
            <ConfigurationOption
              label="External"
              icon={<PersonIcon />}
              active={condition.speakerType === SpeakerCondition.EXTERNAL}
              onClick={() =>
                this.props.conditionChange(condition.set('speakerType', SpeakerCondition.EXTERNAL))
              }
            />
            <ConfigurationOption
              label="Any"
              icon={<BothIcon />}
              active={condition.speakerType === null}
              onClick={() => this.props.conditionChange(condition.set('speakerType', null))}
            />
          </div>
          transcript
        </div>
        <div className="condition-type-selection">
          matches
          <div className="select-field-container">
            <SelectField
              label="Topic"
              options={topics}
              value={selectedValue}
              onChange={selection =>
                this.props.conditionChange(
                  this.props.condition.set('keywordTopicPhrase', {
                    filterWordId: selection,
                  })
                )
              }
              placeholder={'- select topic -'}
            />
          </div>
        </div>
      </div>
    );
  }
}
